<form [formGroup]="predictionForm" (ngSubmit)="onSubmit()" class="space-y-6">

    <div class="flex flex-col md:flex-row gap-6">

        <div class="flex-1 flex flex-col gap-2">
            <label for="eventName" class="font-medium">Nom de l'évènement</label>
            <input id="eventName" formControlName="eventName" type="text" pInputText class="p-2 border text-[16px] rounded w-1/2" />
            <span *ngIf="predictionForm.get('eventName')?.invalid && predictionForm.get('eventName')?.touched"
                class="text-red-500 text-sm">
                Nom de l'évènement obligatoire
            </span>
        </div>
    </div>

    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 flex flex-col gap-2">
            <label for="teamHomeName" class="font-medium">Équipe domicile</label>
            <p-dropdown id="teamHomeName" formControlName="teamHomeName" [options]="teams" [filter]="true" placeholder="Equipe"
                optionLabel="name" optionValue="id" class="w-full"></p-dropdown>
            <span *ngIf="predictionForm.get('teamHomeName')?.invalid && predictionForm.get('teamHomeName')?.touched"
                class="text-red-500 text-sm">
                Nom de l'équipe domicile obligatoire
            </span>
        </div>
        <div class="flex-1 flex flex-col gap-2">
            <label for="teamAwayName" class="font-medium">Équipe extérieure</label>
            <p-dropdown id="teamAwayName" formControlName="teamAwayName" [options]="teams" [filter]="true" placeholder="Equipe"
                optionLabel="name" optionValue="id" class="w-full"></p-dropdown>
            <span *ngIf="predictionForm.get('teamAwayName')?.invalid && predictionForm.get('teamAwayName')?.touched"
                class="text-red-500 text-sm">
                Nom de l'équipe extérieure obligatoire
            </span>
        </div>
    </div>

    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 flex flex-col gap-2">
            <label for="teamHomeConfidence" class="font-medium">Confiance équipe domicile (%)</label>
            <input id="teamHomeConfidence" formControlName="teamHomeConfidence" type="number" pInputText
                class="p-2 border rounded w-full text-[16px]" />
            <span
                *ngIf="predictionForm.get('teamHomeConfidence')?.invalid && predictionForm.get('teamHomeConfidence')?.touched"
                class="text-red-500 text-sm">
                Valeur requise
            </span>
        </div>
        <div class="flex-1 flex flex-col gap-2">
            <label for="teamAwayConfidence" class="font-medium">Confiance équipe extérieure (%)</label>
            <input id="teamAwayConfidence" formControlName="teamAwayConfidence" type="number" pInputText
                class="p-2 border rounded w-full text-[16px]" />
            <span
                *ngIf="predictionForm.get('teamAwayConfidence')?.invalid && predictionForm.get('teamAwayConfidence')?.touched"
                class="text-red-500 text-sm">
                Valeur requise
            </span>
        </div>
    </div>

    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 flex flex-col gap-2">
            <label for="competition" class="font-medium">Compétition</label>
            <p-dropdown id="competition" formControlName="competition" [options]="competitions"
                placeholder="Compétition" optionLabel="name" optionValue="id" class="w-full"></p-dropdown>
            <span *ngIf="predictionForm.get('competition')?.invalid && predictionForm.get('competition')?.touched"
                class="text-red-500 text-sm">
                Compétition obligatoire
            </span>
        </div>
        <div class="flex-1 flex flex-col gap-2">
            <label for="sport" class="font-medium">Sport</label>
            <p-dropdown id="sport" formControlName="sport" [options]="sports" placeholder="Sport"
                optionLabel="sport_name" optionValue="id" class="w-full"></p-dropdown>
            <span *ngIf="predictionForm.get('sport')?.invalid && predictionForm.get('sport')?.touched"
                class="text-red-500 text-sm">
                Sport obligatoire
            </span>
        </div>
    </div>



    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 flex flex-col gap-2">
            <label for="eventDate" class="font-medium">Date de l'évènement</label>
            <input id="eventDate" formControlName="eventDate" type="datetime-local" pInputText
                class="p-2 border rounded w-full md:w-1/2 text-[16px]" />
            <span *ngIf="predictionForm.get('eventDate')?.invalid && predictionForm.get('eventDate')?.touched"
                class="text-red-500 text-sm">
                Date requise
            </span>
        </div>
        <div class="flex-1 flex flex-col gap-2">
            <label for="cote" class="font-medium">Cote</label>
            <input id="cote" formControlName="cote" type="text" pInputText
                class="p-2 border text-[16px] rounded w-full md:w-1/2" />
            <span *ngIf="predictionForm.get('cote')?.invalid && predictionForm.get('cote')?.touched"
                class="text-red-500 text-sm">
                Cote requise
            </span>

        </div>
    </div>







    <div class="flex flex-col gap-2">
        <label for="analysisText" class="font-medium">Analyse</label>
        <textarea id="analysisText" formControlName="analysisText" rows="4" pInputText
            class="p-2 border rounded w-full md:w-2/3"></textarea>
        <span *ngIf="predictionForm.get('analysisText')?.invalid && predictionForm.get('analysisText')?.touched"
            class="text-red-500 text-sm">
            Analyse obligatoire
        </span>
    </div>


    <div *ngIf="isEditMode" class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 flex flex-col gap-2 ">
            <label for="result" class="font-medium">Résultat</label>
            <p-dropdown id="result" formControlName="result" [options]="resultOptions" optionLabel="label"
                optionValue="value" placeholder="Sélectionner un résultat" class="w-1/2">
            </p-dropdown>
            <span *ngIf="predictionForm.get('result')?.invalid && predictionForm.get('result')?.touched"
                class="text-red-500 text-sm">
                Valeur requise
            </span>
        </div>
    </div>

    <div class="text-center mt-6">
        <p-button type="submit" label="{{ isEditMode ? 'Mettre à jour' : 'Ajouter une prédiction' }}"
            [disabled]="predictionForm.invalid"></p-button>
    </div>

    <div *ngIf="customErrors.dateError" class="text-red-500 text-sm text-center">
        La date ne peut pas être dans le passé.
    </div>
    <div *ngIf="customErrors.isEqualTeams" class="text-red-500 text-sm text-center">
        Les équipes ne doivent pas être les mêmes
    </div>

</form>